module.exports = __webpack_public_path__ + "img/sect4-2.6e086f0c.png";